import Svg from 'src/Components/shared/Svg'

const PhoneSvg = () => (
  <Svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4 1.53968L1.15873 3.20635V5.80952C1.38095 7.34921 2.69841 9.33333 4.68254 11.3175C6.66667 13.3016 8.65079 14.619 10.1905 14.8413H12.7937L14.4603 12L10.6667 9.38095L9 11.2857C7.46032 10.4127 5.5873 8.53968 4.71429 7L6.61905 5.33333L4 1.53968ZM4.34921 0L8.15873 5.53968L6.2381 7.20635C6.95238 8.1746 7.8254 9.04762 8.79365 9.76191L10.4603 7.84127L16 11.6508L13.4603 16H10.0952C6.95238 16 0 9.04762 0 5.90476V2.53968L4.34921 0Z'
      fill='#89CAF0'
    />
  </Svg>
)

export default PhoneSvg
